const { createContext } = require("react");

const alertContext = createContext();

export default alertContext; 